import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function RapportExemple() {
  const { t } = useTranslation('inspection');
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.15);

  const scrollToForm = () => {
    const el = document.getElementById('quote-form');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="rapport" className="bg-soft-gray py-16 md:py-24">
      <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          ref={ref}
          className={`bg-white rounded-xl p-6 md:p-10 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl mb-4 text-center">
            {t('rapport_h2')}
          </h2>
          <p className="text-slate-primary/60 text-sm md:text-base leading-relaxed text-center max-w-2xl mx-auto mb-8">
            {t('rapport_desc')}
          </p>

          {/* Visual mockup */}
          <div className="bg-slate-primary rounded-lg p-4 md:p-6 mb-8">
            <div className="flex items-center justify-between mb-4 pb-3 border-b border-white/10">
              <span className="text-white/60 text-xs">RAPPORT D'INSPECTION</span>
              <span className="text-copper text-xs font-semibold">PDF 6 pages</span>
            </div>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <i className="ri-image-line text-copper" />
                <div className="flex-1">
                  <div className="h-2 bg-white/10 rounded w-3/4 mb-1" />
                  <div className="h-2 bg-white/10 rounded w-1/2" />
                </div>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-error-warning-line text-copper" />
                <div className="flex-1">
                  <div className="h-2 bg-white/10 rounded w-5/6 mb-1" />
                  <div className="h-2 bg-white/10 rounded w-2/3" />
                </div>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-calculator-line text-copper" />
                <div className="flex-1">
                  <div className="h-2 bg-white/10 rounded w-4/5 mb-1" />
                  <div className="h-2 bg-white/10 rounded w-1/2" />
                </div>
              </div>
            </div>
          </div>

          <button
            onClick={scrollToForm}
            className="group bg-copper hover:bg-copper-dark text-white font-semibold px-8 py-4 rounded-md text-base transition-all duration-300 flex items-center gap-3 mx-auto whitespace-nowrap"
          >
            {t('rapport_cta')}
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </section>
  );
}